import React from 'react';

const Logo: React.FC<{ size?: number; color?: string }> = ({ size = 32, color = '#22c55e' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ filter: 'drop-shadow(0 0 8px rgba(34, 197, 94, 0.4))' }}
        >
            {/* Outer Hex Shell */}
            <path
                d="M50 5L90 27.5V72.5L50 95L10 72.5V27.5L50 5Z"
                stroke={color}
                strokeWidth="4"
                strokeLinejoin="round"
                opacity="0.8"
            />

            {/* Inner Hatching Core */}
            <rect
                x="35"
                y="35"
                width="30"
                height="30"
                rx="6"
                fill={color}
            >
                <animate
                    attributeName="opacity"
                    values="0.3;1;0.3"
                    dur="3s"
                    repeatCount="indefinite"
                />
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 50 50"
                    to="360 50 50"
                    dur="10s"
                    repeatCount="indefinite"
                />
            </rect>

            {/* Glint effect */}
            <path
                d="M20 30L35 22"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                opacity="0.3"
            />
        </svg>
    );
};

export default Logo;
